/**
 * Created by linjianxi on 2017/1/18.
 */
import * as actions from './actions'
import * as getters from './getter'
import * as types from './mutation-type'

const state = {
  gridData: {}
}
const mutations = {
  [types.GET_RED_LIST] (state, result) {
    state.gridData = result
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/packet/store.js